<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'turmas' })"
            :disabled="criandoTurma"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Turma
        </h1>
      </v-col>
    </v-row>

    <template v-if="carregandoPagina">
      <skeleton-turma-form-loader />
    </template>

    <template v-else>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submitForm)" :disabled="criandoTurma">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" sm="4" md="2">
              <e-label>Código</e-label>
              <v-text-field v-model="form.codigo" dense solo />
            </v-col>

            <ValidationProvider name="Código INEP" rules="numeric|max:10" v-slot="{ errors }">
              <e-label>Código INEP</e-label>

              <v-text-field
                v-model="form.codigo_inep"
                :error-messages="errors"
                dense
                solo
                maxlength="10"
                counter="10"
                placeholder="Preenchido via censo"
                @keypress="onlyNumbers"
                disabled
              />
            </ValidationProvider>

            <v-col class="pt-0 pb-0" cols="12" sm="12" md="4">
              <ValidationProvider name="Descrição" rules="required" v-slot="{ errors }">
                <e-label>Descrição</e-label>
                <v-text-field :error-messages="errors" v-model="form.descricao" dense solo />
              </ValidationProvider>
            </v-col>
            <v-col
              class="pt-0 pb-0"
              cols="12"
              sm="8"
              md="2"
              v-if="form.tipo_de_atendimento === 'Escolarização' || !form.tipo_de_atendimento"
            >
              <ValidationProvider
                name="Limite de Pré-Matrículas"
                rules="integer|min_value:0"
                v-slot="{ errors }"
              >
                <e-label>Limite de Pré-Matrículas</e-label>
                <v-text-field
                  v-model.number="form.limite_prematricula"
                  type="number"
                  min="0"
                  :error-messages="errors"
                  hint="Deixe vazio para ilimitado (Escolarização)"
                  persistent-hint
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="4" md="1">
              <e-label>Notif.</e-label>
              <v-switch v-model="switch1" class="mt-0"></v-switch>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="12" md="6">
              <e-label>Tipo de mediação didático-pedagógica</e-label>
              <e-autocomplete
                :items="$constants.tiposDeMediacaoDidaticoPedagogica"
                :return-object="false"
                :item-value="(value) => value"
                v-model="form.tipos_de_mediacao_didatico_pedagogica"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="12" md="6">
              <e-label>Local de funcionamento diferenciado da turma</e-label>
              <e-autocomplete
                :items="$constants.localDeFuncionamentoDiferenciadoDaTurma"
                :return-object="false"
                :item-value="(value) => value"
                v-model="form.local_de_funcionamento_diferenciado_da_turma"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="12" sm="4" md="2">
              <e-label>Horário Inicial</e-label>
              <v-text-field v-model="form.horario_inicial" dense solo />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="4" md="2">
              <e-label>Horário Final</e-label>
              <v-text-field v-model="form.horario_final" dense solo />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="12" md="4">
              <e-label>Dias da semana da turma</e-label>
              <e-autocomplete
                :items="$constants.diasDaSemana"
                :return-object="false"
                :item-value="(value) => value"
                v-model="form.dias_da_semana"
                label="Selecione uma opção"
                dense
                solo
                multiple
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="6" md="4">
              <e-label>Tipo de atendimento</e-label>
              <e-autocomplete
                :items="$constants.tiposDeAtendimento"
                :return-object="false"
                :item-value="(value) => value"
                v-model="form.tipo_de_atendimento"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="12" sm="12" md="6">
              <e-label>Tipo de atividade complementar</e-label>
              <e-autocomplete
                :items="$constants.atividadesComplementaresList"
                :return-object="false"
                :item-value="(item) => item.codigo"
                :item-text="(item) => `${item.codigo} - ${item.descricao}`"
                v-model="form.tipo_de_atividade_complementar"
                label="Selecione uma opção"
                dense
                solo
                multiple
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="6" md="3">
              <e-label>Modalidade</e-label>
              <e-autocomplete
                :items="$constants.modalidades"
                :return-object="false"
                :item-value="(value) => value"
                v-model="form.modalidade"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="6" md="3">
              <ValidationProvider name="Turno" rules="required" v-slot="{ errors }">
                <e-label>Turno</e-label>
                <e-autocomplete
                  :items="turnosList"
                  :loading="carregandoTurnos"
                  :item-text="(turno) => turno.descricao"
                  :return-object="false"
                  :item-value="(turno) => turno.id"
                  :error-messages="errors"
                  v-model="form.turno_id"
                  label="Selecione uma opção"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>

            <v-col class="pt-0 pb-0" cols="12" sm="6" md="4">
              <e-label>Etapa</e-label>
              <ValidationProvider
                name="Etapa"
                :rules="
                  form.tipo_de_atendimento !== 'Atendimento educacional especializado (AEE)'
                    ? 'required'
                    : ''
                "
                v-slot="{ errors }"
              >
                <e-autocomplete
                  :items="seriesList.filter((serie) => serie.situacao)"
                  :loading="carregandoSeries"
                  :item-text="(serie) => serie.descricao"
                  :return-object="false"
                  :item-value="(serie) => serie.id"
                  :error-messages="errors"
                  @change="verificarSerie"
                  v-model="form.serieIdList"
                  label="Selecione uma opção"
                  dense
                  solo
                  multiple
                />
              </ValidationProvider>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="6" md="4" v-if="mostrarFormCircuito">
              <e-label>Circuito de Notas</e-label>
              <ValidationProvider name="Sala" rules="" v-slot="{ errors }">
                <e-autocomplete
                  :items="circuitoDeNotasList.filter((circuito) => circuito)"
                  :loading="carregandoCircuito"
                  :item-text="(circuito) => circuito.descricao"
                  :return-object="false"
                  :item-value="(circuito) => circuito.id"
                  :error-messages="errors"
                  v-model="form.circuito_nota_id"
                  label="Selecione uma opção"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" sm="6" md="4">
              <ValidationProvider name="TiposDeEnsinos" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Ensino</e-label>
                <e-autocomplete
                  :items="tiposDeEnsinosList"
                  :loading="carregandoTiposDeEnsinos"
                  :item-text="(tipoDeEnsino) => tipoDeEnsino.descricao"
                  :item-value="(tipoDeEnsino) => tipoDeEnsino.id"
                  :error-messages="errors"
                  @change="alterarSistemaBNCC"
                  v-model="form.curso_id"
                  label="Selecione uma opção"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
            <v-col
              class="pt-0 pb-0"
              cols="12"
              sm="6"
              md="4"
              v-if="idTurmasInfantis.includes(form.curso_id)"
            >
              <ValidationProvider name="sistemaBNCC" rules="required" v-slot="{ errors }">
                <e-label>Sistema BNCC</e-label>
                <e-autocomplete
                  :items="sistemaBNCCList.filter((sistema) => !sistema.parent_id)"
                  :loading="carregandoSistemaBNCC"
                  :item-text="(sistemaBNCC) => sistemaBNCC.descricao"
                  :item-value="(sistemaBNCC) => sistemaBNCC.id"
                  :error-messages="errors"
                  v-model="form.sistema_bncc_id"
                  label="Selecione uma opção"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" class="pt-4">
              <v-btn
                color="primary"
                :disabled="criandoTurma"
                :loading="criandoTurma"
                type="submit"
                block
                >Enviar Dados</v-btn
              >
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </template>
  </main-template>
</template>

<script>
import SkeletonTurmaFormLoader from "@/components/SkeletonTurmaFormLoader.vue";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel, SkeletonTurmaFormLoader },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.loadData();
  },
  watch: {
    switch1(newVal) {
      if (newVal) {
        this.form.notifiq = 1;
        return;
      }
      this.form.notifiq = 0;
    },
    "form.tipo_de_atendimento": function (newVal) {
      // Limpa o limite de pré-matrícula se o tipo de atendimento não for Escolarização
      if (newVal && newVal !== "Escolarização") {
        this.form.limite_prematricula = null;
      }
    },
  },
  data() {
    return {
      circuitoFundamentalMenorId: 6,
      form: {},
      seriesList: [],
      circuitoDeNotasList: [],
      turnosList: [],
      sistemaBNCCList: [],
      tiposDeEnsinosList: [],
      criandoTurma: false,
      carregandoSeries: false,
      carregandoTurnos: false,
      carregandoCircuito: false,
      carregandoTiposDeEnsinos: false,
      carregandoSistemaBNCC: false,
      carregandoPagina: true,
      switch1: false,
      idTurmasInfantis: [1],
      arraySeriesFundMenor: [4, 5, 6, 7, 8],
      arraySeriesEja: [19, 20],
      mostrarFormCircuito: true,
    };
  },
  methods: {
    onlyNumbers(event) {
      const char = String.fromCharCode(event.keyCode);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },

    verificarSerie() {
      if (
        this.arraySeriesFundMenor.some((item) => this.form.serieIdList.includes(item)) ||
        this.arraySeriesEja.some((item) => this.form.serieIdList.includes(item))
      ) {
        this.form.circuito_nota_id = this.circuitoFundamentalMenorId;
        this.mostrarFormCircuito = false;
      } else {
        this.mostrarFormCircuito = true;
      }
    },
    alterarSistemaBNCC() {
      if (!this.form.isInfantil) this.form.sistema_bncc_id = null;
    },
    async submitForm() {
      this.criandoTurma = true;
      try {
        if (this.editing) {
          await this.$services.turmasService.atualizarTurma(this.form);
          this.$toast.success("Turma Atualizada com sucesso");
        } else {
          await this.$services.turmasService.criarTurma(this.form);
          this.$toast.success("Turma criada com sucesso");
        }
        this.$router.push({ name: "turmas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.criandoTurma = false;
    },
    async loadData() {
      this.carregandoPagina = true;
      this.$loaderService.open("Carregando dados");
      try {
        if (this.editing) {
          const { turma_id } = this.$route.params;
          const payload = await this.$services.turmasService.visualizarTurma(turma_id);
          const series = await payload.turma.series.map((serie) => (serie.id ? serie.id : serie));
          this.form = { ...payload.turma, serieIdList: series };
          this.switch1 = parseInt(payload.turma.notifiq, 10) === 1;
          this.verificarSerie();
        }
        this.tiposDeEnsinosList = await this.$services.tiposDeEnsinosService.syncAll();
        this.turnosList = await this.$services.turnosService.syncAll();
        this.seriesList = await this.$services.seriesService.syncAll();
        this.circuitoDeNotasList = await this.$services.circuitoNotasService.syncAll();
        const response = await this.$services.sistemaBNCCService.listarTodos();
        this.sistemaBNCCList = response.sistema;
        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
      this.carregandoPagina = false;
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: clamp(1.25rem, 4vw, 2rem);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

@media (max-width: 600px) {
  h1 {
    font-size: 1.25rem;
  }

  .v-col {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }

  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot,
  .v-select.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    min-height: 40px;
  }
}

@media (min-width: 600px) and (max-width: 960px) {
  h1 {
    font-size: 1.5rem;
  }
}

.v-btn.x-small {
  min-width: 36px !important;
  padding: 0 8px !important;
}

.v-col:has(.v-btn[type="submit"]) {
  margin-top: 1rem;
}
</style>
